import React from 'react';
import { Image, Separator } from '@gik/ui';
import HomepageTestimonial from '@gik/homepage/components/HomepageTestimonial/HomepageTestimonial';
import { UIVariant } from '@gik/ui/types';
import { ITestimonial } from '@gik/core/models/gik/ITestimonial';
import bemBlock from '@gik/core/utils/bemBlock';
import Link from '@/components/Link';

export interface FeatureTileProps {
  variant: UIVariant | 'danger' | 'success';
  linkIcon: string;
  linkLabel: string;
  linkRef: string;
  testimonial: Partial<ITestimonial>;
  reversed?: boolean;
}

const blockName = 'feature-tile';

export default function FeatureTile({
  variant,
  linkIcon,
  linkLabel,
  linkRef,
  testimonial,
  reversed = false,
}: FeatureTileProps) {
  const bem = bemBlock(blockName);

  // TODO align separators again
  return (
    <div className={bem(null, [{ reversed: reversed }])}>
      <Separator className={bem('separator')} />
      <HomepageTestimonial testimonial={testimonial} reversed={reversed} />
      <Separator className={bem('separator')} />
      <Link href={linkRef}>
        <a className={bem('link', null, `tw-text-${variant}-500`)}>
          <Image className={bem('learn-more-icon')} src={linkIcon} />
          <div className={bem('learn-more-copy')}>{linkLabel}</div>
        </a>
      </Link>
    </div>
  );
}
